import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { PayoutActionTypes } from "./constants";
import { payoutApiResponseError, payoutApiResponseSuccess } from "./actions";
import { getPayoutsApi, getPayoutsDetailsApi } from "../../helpers/api/payout";

function* getPayouts({ payload: { influencer_id, type, from, to } }: any): SagaIterator {
  

  try {
    const response = yield call(getPayoutsApi, influencer_id, type, from, to);
    const currencyData = response?.data;

    yield put(payoutApiResponseSuccess(PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER, currencyData));
  } catch (error: any) {
    yield put(payoutApiResponseError(PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER, error));
  }
}

function* getPayoutsDetails({ payload: { influencer_id, from, to } }: any): SagaIterator {
  try {
    const response = yield call(getPayoutsDetailsApi, influencer_id, from, to);
    const currencyData = response?.data;

    yield put(payoutApiResponseSuccess(PayoutActionTypes.GET_PAYOUT_DETAILS, currencyData));
  } catch (error: any) {
    yield put(payoutApiResponseError(PayoutActionTypes.GET_PAYOUT_DETAILS, error));
  }
}

export function* watchGetPayouts() {
  yield takeEvery(PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER, getPayouts);
}

export function* watchGetPayoutsDetails() {
  yield takeEvery(PayoutActionTypes.GET_PAYOUT_DETAILS, getPayoutsDetails);
}

function* payoutSaga() {
  yield all([fork(watchGetPayouts), fork(watchGetPayoutsDetails)]);
}

export default payoutSaga;
